export default "__VITE_ASSET__CQv74WT9__"